// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

export default class JwPlayer extends Component<Props> {
    componentDidMount() {
        const { video_id, player_id } = this.props.content;
        if (video_id === '' || player_id === '') return;

        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts) loadScripts(customScripts);
        else {
            const script = document.createElement('script');
            script.src = `//content.jwplatform.com/players/${video_id}-${player_id}.js`;
            script.id = `jwplayer-script-${video_id}-${player_id}`;

            if (document.body) document.body.appendChild(script);
        }
    }

    componentWillUnmount() {
        const { video_id, player_id } = this.props.content;

        const script = document.getElementById(
            `jwplayer-script-${video_id}-${player_id}`
        );
        if (script) {
            script.outerHTML = '';
        }
    }

    render() {
        const { video_id, player_id } = this.props.content;

        return <div id={`botr_${video_id}_${player_id}_div`} />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/JwPlayer.js